import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getInvitateUsers = async (page, phone) => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/user/invitate_users?page=${page}&phone=${phone}`, {
    headers: { Authorization: token },
  });
};

export const getUsers = async (page, user_type, isNew, isBan) => {
  const token = await cookie.get("token");
  return await axios.get(
    `${proxy}/user/all_users/${user_type}/${page}/${isNew}/${isBan}`,
    {
      headers: { Authorization: token },
    },
  );
};

export const getInvitationUsers = async (page) => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/user/all_invitation_users/${page}`, {
    headers: { Authorization: token },
  });
};

export const getUsersInvitation = async (code, page) => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/user/invitation/${code}/${page}`, {
    headers: { Authorization: token },
  });
};

export const searchUsers = async (userType, search, page, isNew, isBan) => {
  const token = await cookie.get("token");
  return await axios.post(
    `${proxy}/user/get_data_of_user/${userType}/${page}`,
    { search: search, isNew: isNew, isBan: isBan },
    {
      headers: { Authorization: token },
    },
  );
};

export const getUserNotificationUsers = async (user_type) => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/user/all/${user_type}`, {
    headers: { Authorization: token },
  });
};

export const banUser = async (id) => {
  const token = await cookie.get("token");
  return await axios.put(
    `${proxy}/user/ban/${id}`,
    {},
    {
      headers: { Authorization: token },
    },
  );
};

export const unbanUser = async (id) => {
  const token = await cookie.get("token");
  return await axios.put(
    `${proxy}/user/unban/${id}`,
    {},
    {
      headers: { Authorization: token },
    },
  );
};

export const doneUser = async (id) => {
  const token = await cookie.get("token");
  return await axios.put(
    `${proxy}/user/done/${id}`,
    {},
    {
      headers: { Authorization: token },
    },
  );
};

export const updateEarning = async (id, earning) => {
  const token = await cookie.get("token");
  return await axios.put(
    `${proxy}/user/update_earning`,
    { user_id: id, earning: earning },
    {
      headers: { Authorization: token },
    },
  );
};

export const downloadExcel = async () => {
  const res = await fetch(`${proxy}/user/excel`);
  const blob = await res.blob();

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "users.xlsx";
  a.click();
  window.URL.revokeObjectURL(url);
};

export const hideUser = async (id, formDate) => {
  const token = await cookie.get("token");
  return await axios.put(`${proxy}/user/hide/${id}`, formDate, {
    headers: { Authorization: token },
  });
};

export const bulkHideUser = async (ids) => {
  const token = await cookie.get("token");
  return await axios.put(
    `${proxy}/user/bulk_hide`,
    { ids: ids },
    {
      headers: { Authorization: token },
    },
  );
};

export const getUserTeam = async () => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/user/inv_users`, {
    headers: { Authorization: token },
  });
};
